<template>
  <section class="navigation-search">
    <div class="navigation-search__bar">
      <InputSearchQuery id="search" placeholder="Que cherchez-vous?" />
    </div>

    <div class="navigation-search__filters">
      <RouterLink
        :to="getTypeQuery('all')"
        class="navigation-search__tags tag -light"
        :class="{ '-active': !$route.query.type }"
        replace
        exact
      >
        Toutes les types de publications
      </RouterLink>

      <RouterLink
        :to="getTypeQuery('article')"
        class="navigation-search__tags tag -light"
        :class="{ '-active': $route.query.type === 'article' }"
        replace
        exact
      >
        <SvgIcon id="content-article" />
        Articles
      </RouterLink>

      <RouterLink
        :to="getTypeQuery('theme')"
        class="navigation-search__tags tag -light"
        :class="{ '-active': $route.query.type === 'theme' }"
        replace
        exact
      >
        <SvgIcon id="content-folder" />
        Dossiers thématiques
      </RouterLink>

      <RouterLink
        :to="getTypeQuery('letter')"
        class="navigation-search__tags tag -light"
        :class="{ '-active': $route.query.type === 'letter' }"
        replace
        exact
      >
        <SvgIcon id="content-file" />
        Lettres ouvertes
      </RouterLink>

      <RouterLink
        :to="getTypeQuery('balado')"
        class="navigation-search__tags tag -light"
        :class="{ '-active': $route.query.type === 'balado' }"
        replace
        exact
      >
        <SvgIcon id="content-podcast" />
        Balados
      </RouterLink>

      <RouterLink
        :to="getTypeQuery('opinion')"
        class="navigation-search__tags tag -light"
        :class="{ '-active': $route.query.type === 'opinion' }"
        replace
        exact
      >
        <SvgIcon id="content-declaration" />
        Texte d'opinion
      </RouterLink>

      <RouterLink
        :to="getTypeQuery('report')"
        class="navigation-search__tags tag -light"
        :class="{ '-active': $route.query.type === 'report' }"
        replace
        exact
      >
        <svg-icon id="content-list" />
        Rapports
      </RouterLink>

      <RouterLink
        :to="getTypeQuery('memoir')"
        class="navigation-search__tags tag -light"
        :class="{ '-active': $route.query.type === 'memoir' }"
        replace
        exact
      >
        <svg-icon id="content-chat" />
        Mémoires et avis
      </RouterLink>

      <RouterLink
        :to="getTypeQuery('annual')"
        class="navigation-search__tags tag -light"
        :class="{ '-active': $route.query.type === 'annual' }"
        replace
        exact
      >
        <svg-icon id="content-date" />
        Rapports annuels
      </RouterLink>

      <RouterLink
        :to="getTypeQuery('newsletter')"
        class="navigation-search__tags tag -light"
        :class="{ '-active': $route.query.type === 'newsletter' }"
        replace
        exact
      >
        <svg-icon id="content-mail" />
        Infolettres
      </RouterLink>

      <RouterLink
        :to="getTypeQuery('declaration')"
        class="navigation-search__tags tag -light"
        :class="{ '-active': $route.query.type === 'declaration' }"
        replace
        exact
      >
        <svg-icon id="content-declaration" />
        Déclarations
      </RouterLink>
    </div>

    <KeywordPickerQuery :dataset="allPublications" />
  </section>
</template>

<script>
export default {
  name: 'PublicationsSearch',
  computed: {
    allPublications() {
      return this.$wp.restPublications || []
    }
  },
  methods: {
    getTypeQuery(type) {
      const { page, type: currentType, ...queryRest } = this.$route.query
      const query = type === 'all' || currentType === type ? queryRest : { ...queryRest, type }
      return { query }
    }
  }
}
</script>
